import { ArrowsClockwiseIcon as PhosphorArrowsClockwiseIcon } from "@phosphor-icons/react/dist/ssr/ArrowsClockwise";

import { createAppIcon } from "@/components/createAppIcon";

export const SyncIcon = /* @__PURE__ */ createAppIcon(PhosphorArrowsClockwiseIcon);
